import { SpinningIcon } from '../Icon';
import { styled } from '@mui/material';

import { FilterMenuProps, FiltersMenu } from './Filters';
import { SearchInput, type SearchProps } from './SearchInput';

type TableFilterProps = {
  error?: boolean;
  onErrorReset?: () => void;
} & ((
  | {
      hideFilter: true;
      filtersProps?: FilterMenuProps;
    }
  | {
      hideFilter?: false;
      filtersProps: FilterMenuProps;
    }
) &
  ({ hideSearch: true; searchProps?: SearchProps } | { hideSearch?: false; searchProps: SearchProps }));

const TableFilterWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '10px'
});

const SearchWrapper = styled('div')({
  minWidth: '350px'
});

const FiltersWrapper = styled('div')({
  flex: '1',
  height: '100%'
});

const SaveFiltersWrapper = styled('div')({
  minWidth: '450px'
});

export function TableFilter(props: TableFilterProps) {
  const { hideFilter, hideSearch, error, onErrorReset } = props;

  const errorFilters = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: 8
      }}
    >
      <SpinningIcon name="loadingSpinner" />
      Failed loading Filters.
      {onErrorReset && (
        <div
          onClick={() => onErrorReset()}
          style={{
            cursor: 'pointer',
            color: 'hsla(192, 60%, 64%, 1)'
          }}
        >
          Retry
        </div>
      )}
    </div>
  );

  return error ? (
    errorFilters
  ) : (
    <TableFilterWrapper>
      {!hideSearch && (
        <SearchWrapper>
          <SearchInput {...props.searchProps} />
        </SearchWrapper>
      )}
      {!hideFilter && (
        <FiltersWrapper>
          <FiltersMenu {...props.filtersProps} />
        </FiltersWrapper>
      )}
    </TableFilterWrapper>
  );
}
